/**
  基础路由配置
*/
import { lazy } from 'ice';
import React from 'react';
import ContainerManage from '@/pages/ContainerManage';
import ContainerManageDetail from '@/pages/ContainerManageDetail';
import ContainerType from '@/pages/ContainerType';
import DistributionWall from '@/pages/DistributionWall';
import DistributionDetail from '@/pages/DistributionDetail';
import OperationFloor from '@/pages/OperationFloor';
import ChannelGroup from '@/pages/ChannelGroup';
import OrderChannelGroup from '@/pages/OrderChannelGroup';
import LocationConfig from '@/pages/LocationConfig';
import WorkArea from '@/pages/WorkArea';
import PackingMaterial from '@/pages/PackingMaterial';
import AlgorithmConfig from '@/pages/AlgorithmConfig';
import basedataAgv from '@/pages/BasedataAgv';
import TimeConfiguration from '@/pages/TimeConfiguration';
import ServiceList from '@/pages/ServiceList';
import ServiceAdd from '@/pages/ServiceAdd';
import ServiceDetail from '@/pages/ServiceDetail';
import AgentAdd from '@/pages/AgentAdd';
import ServiceLook from '@/pages/ServiceLook';
import AccountList from '@/pages/AccountList';
import AttendanceManagement from '@/pages/AttendanceManagement';
import OutboundConfig from '@/pages/OutboundConfig';
import AigoSetting from '@/pages/AigoSetting';
import DDPushConfig from '@/pages/DDPushConfig';
import CustomerGroupConfig from '@/pages/CustomerGroupConfig';
import DeviceManageList from '@/pages/DeviceManageList';
import TotalOrderConfig from '@/pages/TotalOrderConfig';
import ReturnPolicyConfig from '@/pages/ReturnPolicyConfig';
import SystemSwitchConfig from '@/pages/SystemSwitchConfig';
import ReplenishPushConfig from '@/pages/ReplenishPushConfig';
import TianjiNewProductManagement from '@/pages/TianjiNewProductManagement';

// const ContainerManage = lazy(() => import(/* webpackChunkName: 'ContainerManage' */ '@/pages/ContainerManage'));
// const ContainerManageDetail = lazy(
//   () => import(/* webpackChunkName: 'ContainerManageDetail' */ '@/pages/ContainerManageDetail'),
// );
// const ContainerType = lazy(() => import(/* webpackChunkName: 'ContainerType' */ '@/pages/ContainerType'));
// const DistributionWall = lazy(() => import(/* webpackChunkName: 'DistributionWall' */ '@/pages/DistributionWall'));
// const DistributionDetail = lazy(
//   () => import(/* webpackChunkName: 'DistributionDetail' */ '@/pages/DistributionDetail'),
// );
// const OperationFloor = lazy(() => import(/* webpackChunkName: 'OperationFloor' */ '@/pages/OperationFloor'));
// const ChannelGroup = lazy(() => import(/* webpackChunkName: 'ChannelGroup' */ '@/pages/ChannelGroup'));
// const OrderChannelGroup = lazy(() => import(/* webpackChunkName: 'OrderChannelGroup' */ '@/pages/OrderChannelGroup'));
// const WorkArea = lazy(() => import(/* webpackChunkName: 'WorkArea' */ '@/pages/WorkArea'));
// const PackingMaterial = lazy(() => import(/* webpackChunkName: 'PackingMaterial' */ '@/pages/PackingMaterial'));
// const AlgorithmConfig = lazy(() => import(/* webpackChunkName: 'AlgorithmConfig' */ '@/pages/AlgorithmConfig'));
// const basedataAgv = lazy(() => import(/* webpackChunkName: 'BasedataAgv' */ '@/pages/BasedataAgv'));
// const TimeConfiguration = lazy(() => import(/* webpackChunkName: 'TimeConfiguration' */ '@/pages/TimeConfiguration'));
// const ServiceList = lazy(() => import(/* webpackChunkName: 'ServiceList' */ '@/pages/ServiceList'));
// const ServiceAdd = lazy(() => import(/* webpackChunkName: 'ServiceAdd' */ '@/pages/ServiceAdd'));
// const ServiceDetail = lazy(() => import(/* webpackChunkName: 'ServiceDetail' */ '@/pages/ServiceDetail'));
// const AgentAdd = lazy(() => import(/* webpackChunkName: 'AgentAdd' */ '@/pages/AgentAdd'));
// const ServiceLook = lazy(() => import(/* webpackChunkName: 'ServiceLook' */ '@/pages/ServiceLook'));
// const AccountList = lazy(() => import(/* webpackChunkName: 'AccountList' */ '@/pages/AccountList'));

export default [
  {
    path: '/basedata/containermanage',
    exact: true,
    // component: ContainerManage,
    component: React.lazy(() => import(/* webpackChunkName: 'ContainerManage' */ '@/pages/ContainerManage')),
  },
  {
    path: '/basedata/containermanage/detail/:tid',
    exact: true,
    // component: ContainerManageDetail,
    component: React.lazy(
      () => import(/* webpackChunkName: 'ContainerManageDetail' */ '@/pages/ContainerManageDetail'),
    ),
  },
  {
    path: '/basedata/containertype',
    // component: ContainerType,
    component: React.lazy(() => import(/* webpackChunkName: 'ContainerType' */ '@/pages/ContainerType')),
  },
  {
    path: '/basedata/distributionwall',
    // component: DistributionWall,
    component: React.lazy(() => import(/* webpackChunkName: 'DistributionWall' */ '@/pages/DistributionWall')),
  },
  {
    path: '/basedata/distributiondetail/:tid',
    exact: true,
    // component: DistributionDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'DistributionDetail' */ '@/pages/DistributionDetail')),
  },
  {
    path: '/basedata/operationfloor',
    // component: OperationFloor,
    component: React.lazy(() => import(/* webpackChunkName: 'OperationFloor' */ '@/pages/OperationFloor')),
  },
  {
    path: '/basedata/channelgroup',
    // component: ChannelGroup,
    component: React.lazy(() => import(/* webpackChunkName: 'ChannelGroup' */ '@/pages/ChannelGroup')),
  },
  {
    path: '/basedata/orderchannelgroup',
    // component: OrderChannelGroup,
    component: React.lazy(() => import(/* webpackChunkName: 'OrderChannelGroup' */ '@/pages/OrderChannelGroup')),
  },
  {
    path: '/basedata/loadingchannelgroup',
    // component: LoadingChannelGroup,
    component: React.lazy(() => import(/* webpackChunkName: 'OrderChannelGroup' */ '@/pages/LoadingChannelGroup')),
  },
  {
    path: '/basedata/locationconfig',
    // component: LocationConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'LocationConfig' */ '@/pages/LocationConfig')),
  },
  {
    path: '/basedata/locationMixConfig',
    // component: locationMixConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'LocationConfig' */ '@/pages/LocationMixConfig')),
  },
  {
    path: '/basedata/workarea',
    // component: WorkArea,
    component: React.lazy(() => import(/* webpackChunkName: 'WorkArea' */ '@/pages/WorkArea')),
  },
  {
    path: '/basedata/packingmaterial',
    // component: PackingMaterial,
    component: React.lazy(() => import(/* webpackChunkName: 'PackingMaterial' */ '@/pages/PackingMaterial')),
  },
  {
    path: '/basedata/algorithmConfig',
    // component: AlgorithmConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'AlgorithmConfig' */ '@/pages/AlgorithmConfig')),
  },
  {
    path: '/basedata/stockMatch',
    // component: stockMatch,
    component: React.lazy(() => import(/* webpackChunkName: 'StockMatch' */ '@/pages/StockMatch')),
  },
  {
    path: '/basedata/basedataAgv',
    // component: basedataAgv,
    component: React.lazy(() => import(/* webpackChunkName: 'basedataAgv' */ '@/pages/BasedataAgv')),
  },
  {
    path: '/basedata/timeconfig',
    // component: TimeConfiguration,
    component: React.lazy(() => import(/* webpackChunkName: 'TimeConfiguration' */ '@/pages/TimeConfiguration')),
  },
  {
    path: '/basedata/outboundConfig',
    // component: OutboundConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'OutboundConfig' */ '@/pages/OutboundConfig')),
  },
  {
    path: '/basedata/serviceList',
    // component: ServiceList,
    component: React.lazy(() => import(/* webpackChunkName: 'ServiceList' */ '@/pages/ServiceList')),
  },
  {
    path: '/basedata/serviceadd',
    // component: ServiceAdd,
    component: React.lazy(() => import(/* webpackChunkName: 'ServiceAdd' */ '@/pages/ServiceAdd')),
  },
  {
    path: '/basedata/servicedetails/:tid',
    // component: ServiceDetail,
    component: React.lazy(() => import(/* webpackChunkName: 'ServiceDetail' */ '@/pages/ServiceDetail')),
  },
  {
    path: '/basedata/agentadd',
    // component: AgentAdd,
    component: React.lazy(() => import(/* webpackChunkName: 'AgentAdd' */ '@/pages/AgentAdd')),
  },
  {
    path: '/basedata/serviclook/:tid',
    // component: ServiceLook,
    component: React.lazy(() => import(/* webpackChunkName: 'ServiceLook' */ '@/pages/ServiceLook')),
  },
  {
    path: '/basedata/accountlist',
    // component: AccountList,
    component: React.lazy(() => import(/* webpackChunkName: 'AccountList' */ '@/pages/AccountList')),
  },
  {
    path: '/basedata/attendanceManagement',
    // component: AttendanceManagement,
    component: React.lazy(() => import(/* webpackChunkName: 'AttendanceManagement' */ '@/pages/AttendanceManagement')),
  },
  {
    path: '/basedata/AigoSetting',
    // component: AigoSetting,
    component: React.lazy(() => import(/* webpackChunkName: 'AigoSetting' */ '@/pages/AigoSetting')),
  },
  {
    path: '/basedata/ddpushconfig',
    // component: DDPushConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'DDPushConfig' */ '@/pages/DDPushConfig')),
  },
  {
    path: '/basedata/customerGroupConfig',
    // component: CustomerGroupConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'CustomerGroupConfig' */ '@/pages/CustomerGroupConfig')),
  },
  {
    path: '/basedata/device/manage',
    // component: DeviceManageList,
    component: React.lazy(() => import(/* webpackChunkName: 'DeviceManageList' */ '@/pages/DeviceManageList')),
  },
  {
    path: '/basedata/totalorderconfig',
    // component: TotalOrderConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'TotalOrderConfig' */ '@/pages/TotalOrderConfig')),
  },
  {
    path: '/basedata/returnPolicyConfig',
    // component: ReturnPolicyConfig,
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnPolicyConfig' */ '@/pages/ReturnPolicyConfig')),
  },
  {
    path: '/basedata/systemswitch/config',
    component: React.lazy(() => import(/* webpackChunkName: 'SystemSwitchConfig' */ '@/pages/SystemSwitchConfig')),
  },
  {
    path: '/basedata/replenish/pushconfig',
    component: React.lazy(() => import(/* webpackChunkName: 'ReplenishPushConfig' */ '@/pages/ReplenishPushConfig')),
  },
  {
    path: '/basedata/tjnewproductmanagement',
    component: React.lazy(
      () => import(/* webpackChunkName: 'TianjiNewProductManagement' */ '@/pages/TianjiNewProductManagement'),
    ),
  },
  {
    path: '/basedata/shortPickingConfig',
    component: React.lazy(() => import(/* webpackChunkName: 'ShortPickingConfig' */ '@/pages/ShortPickingConfig')),
  },
  {
    path: '/basedata/returnDeliveryConfig',
    component: React.lazy(() => import(/* webpackChunkName: 'ReturnDeliveryConfig' */ '@/pages/ReturnDeliveryConfig')),
  },
  {
    path: '/basedata/predictiveData',
    component: React.lazy(() => import(/* webpackChunkName: 'predictiveData' */ '@/pages/PredictiveData')),
  },
  {
    path: '/basedata/stockPasswordManage',
    component: React.lazy(() => import(/* webpackChunkName: 'stockPasswordManage' */ '@/pages/StockPasswordManage')),
  },
  {
    path: '/basedata/servicerule',
    component: React.lazy(() => import('@/pages/BasedataServer')),
  },
  {
    path: '/basedata/MeasurementSortingConfigDWS',
    component: React.lazy(() => import('@/pages/MeasurementSortingConfigDWS')),
  },
  {
    path: '/basedata/serviceProviderOrderNumberRules',
    component: React.lazy(() => import('@/pages/serviceProviderOrderNumberRules')),
  },
  {
    path: '/basedata/PickByLocationConfig',
    component: React.lazy(() => import('@/pages/PickByLocationConfig')),
  },
  {
    path: '/basedata/PackRequirements',
    component: React.lazy(() => import('@/pages/PackRequirements')),
  },
  {
    path: '/basedata/groupOrderRuleConfig',
    component: React.lazy(() => import('@/pages/GroupOrderRuleConfig')),
  },
  {
    path: '/basedata/urgentReplenishConfig',
    component: React.lazy(() => import('@/pages/UrgentReplenishConfig')),
  },
  {
    path: '/basedata/pickTaskConfigs',
    component: React.lazy(() => import('@/pages/PickTaskConfigs')),
  },
];
